/**
 * @group Telehealth
 * @summary Default values and fallback constants for telehealth features
 *
 * @remarks
 * Contains default TTLs, thresholds, durations, display name fallbacks, and
 * telehealth-specific status/error code strings. These are used as fallbacks
 * when environment variables are not set, and for response payloads.
 *
 * @example
 * ```typescript
 * import { TELEHEALTH_DEFAULTS } from '@shared/constants';
 *
 * const ttl = parsedEnvTtl ?? TELEHEALTH_DEFAULTS.SESSION_CREDENTIAL_TTL_SECONDS;
 * const displayName = userName ?? TELEHEALTH_DEFAULTS.DISPLAY_NAMES.PATIENT;
 * ```
 */
export const TELEHEALTH_DEFAULTS = {
  SESSION_CREDENTIAL_TTL_SECONDS: 600,
  STALE_THRESHOLD_SECONDS: 120,
  JOIN_TICKET_TTL_SECONDS: 300,
  CONSULTATION_DURATION_MINUTES: 30,

  DISPLAY_NAMES: {
    PATIENT: 'Patient',
    CLINICIAN: 'Clinician',
    PARTICIPANT: 'Participant',
  },

  ERROR_CODES: {
    CONSULTATION_NOT_FOUND: 'CONSULTATION_NOT_FOUND',
    CONSULTATION_INVALID_STATUS: 'CONSULTATION_INVALID_STATUS',
  },

  RESPONSE_STATUS: {
    READY: 'ready',
  },
} as const;
